import { fetchDashboard } from "./actions/fetchDashboard";
import { getDashboard } from "./actions/getDashboard";
import { enableCollecting } from "@/public/store/modules/dashboard/actions/enableCollecting";
import { getDepositsStats } from "@/public/store/modules/dashboard/actions/getDepositsStats";

export const actions = {
    fetchDashboard,
    getDashboard,
    enableCollecting,
    getDepositsStats
};
